<div class="tidy-autocomplete-field">
  @if (label) {
    <tidy-text
      [fieldLabel]="label"
      class="field-label"
      [class.error]="!form?.valid && submitted" />
  }

  <div
    #inputContainer
    class="input-container"
    [class.invalid-field]="!form?.valid && submitted"
    [class.focused]="isFocused"
    matAutocompleteOrigin
    #origin="matAutocompleteOrigin"
    (click)="autoInput.focus()">

    @if (icon) {
      <tidy-image [src]="icon" class="input-icon no-right-margin" />
    }

    <input
      #autoInput
      type="text"
      [placeholder]="helperText || '' | translate"
      (focus)="setFocused(true)"
      (focusout)="onFocusOut()"
      (keydown)="onKeyDown()"
      (keyup)="onKeyUp($event.target.value)"
      [matAutocomplete]="auto"
      [matAutocompleteConnectedTo]="origin"
      [value]="getValue()" />

    @if (isSearching) {
      <div class="search-spinner">
        <mat-spinner diameter="16" />
      </div>
    }

    <mat-autocomplete
      #auto="matAutocomplete"
      [panelWidth]="panelWidth"
      [class]="showGoogleIcon === true ? 'powered-by-google' : ''"
      panelClass="tidy-autocomplete-panel">
      @if ((showOnFocus || touchUpdate) && inputLength >= minSearchLength) {
        @if (isToSearchBetweenOptions) {
          @for (option of filteredOptionsList; track option) {
            <mat-option
              (click)="choseItem(option)"
              [value]="option.display">
              {{ option.display }}
            </mat-option>
          }
        }
        @if (!isToSearchBetweenOptions) {
          @for (option of options; track option) {
            <mat-option
              (click)="choseItem(option)"
              [value]="option.display">
              {{ option.display }}
            </mat-option>
          }
        }
      }
    </mat-autocomplete>
  </div>

  @if (!form?.valid && submitted) {
    <tidy-error-message [text]="errorMessage" />
  }
</div>
